import React from 'react';
import { Container } from 'react-bootstrap';

function ProjectHouse() {
  return (
    <Container className="mt-4">
      <h1>Проект: Строим мой новый домик</h1>
      <p>Здесь будет галерея работ и описание проекта "Строим мой новый домик".</p>
      
      <hr />

      <h2>Серия 1</h2>
      <video width="100%" controls>
        <source src="/videos/домик мечты 1 серия.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Сюда можно будет добавить галерею работ по аналогии с Gallery.js */}
    </Container>
  );
}

export default ProjectHouse;
